import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  template: `
    <div class="modal-header pb-0">
      <div class="font-xl fw-bold"
           [translate]="'modal.woltInfo.title'">
        We offer delivery to your door
      </div>

      <i class="icon-close" (click)="modal.dismiss()"></i>
    </div>

    <div class="modal-body py-4">
      <div class="font-sm"
           [translate]="'modal.woltInfo.description'">
        We deliver within a 15-kilometre radius. The exact delivery fee will be calculated and displayed once you provide your address
        during the checkout process.
      </div>
    </div>
  `
})
export class ThirdPartyInfoModalComponent {
  constructor(public modal: NgbActiveModal) {
  }
}
